import * as strings from '../globals/strings';

export const LANG_EN = 'en';
export const LANG_FR = 'fr';

export const LANGUAGES = [
    { key: LANG_EN, name: strings.LANGUAGE_NAMES.ENGLISH },
    { key: LANG_FR, name: strings.LANGUAGE_NAMES.FRENCH },
];

let lang = LANG_EN;

export function getLanguageStrings(lang) {
    //let lang = getLanguage();
    if (lang == LANG_EN) {
        return strings.en;
    } else if (lang == LANG_FR) {
        return strings.fr;
    } else {
        return null;
    }
}

export function getLanguages() {
    let arr = [ LANG_EN, LANG_FR ];
}

export function getTargetLanguage(lang) {
    if (lang == LANG_EN) {
        return LANG_FR;
    } else if (lang == LANG_FR) {
        return LANG_EN;
    } else {
        return LANG_EN;
    }

}
